export default __webpack_public_path__ + "static/media/chain-15.36523904.png";